'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_RecipeEditor$Props(recipeParsingResults, onRecipeSaveComplete, onRecipeSaveUnparsable, onRecipeIgnore, saveText, urlOverride) {
  this.zq = null;
  this.SD = null;
  this.SE = null;
  this.SC = null;
  this.SF = null;
  this.LR = null;
  this.zq = recipeParsingResults;
  this.SD = onRecipeSaveComplete;
  this.SE = onRecipeSaveUnparsable;
  this.SC = onRecipeIgnore;
  this.SF = saveText;
  this.LR = urlOverride;
}
export { $c_Lmealorama_components_RecipeEditor$Props as $c_Lmealorama_components_RecipeEditor$Props };
$p = $c_Lmealorama_components_RecipeEditor$Props.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_RecipeEditor$Props;
/** @constructor */
function $h_Lmealorama_components_RecipeEditor$Props() {
}
export { $h_Lmealorama_components_RecipeEditor$Props as $h_Lmealorama_components_RecipeEditor$Props };
$h_Lmealorama_components_RecipeEditor$Props.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 418637176, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_RecipeEditor$Props)) {
    var x = this.zq;
    var x$2 = x$0.zq;
    if (((((((x === null) ? (x$2 === null) : x.f(x$2)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.SD, x$0.SD)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.SE, x$0.SE)) && $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.SC, x$0.SC)) && (this.SF === x$0.SF))) {
      var x$3$1 = this.LR;
      var x$4$1 = x$0.LR;
      return ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.f(x$4$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 6;
});
$p.r = (function() {
  return "Props";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.zq;
      break;
    }
    case 1: {
      return this.SD;
      break;
    }
    case 2: {
      return this.SE;
      break;
    }
    case 3: {
      return this.SC;
      break;
    }
    case 4: {
      return this.SF;
      break;
    }
    case 5: {
      return this.LR;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_RecipeEditor$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kh)));
}
export { $isArrayOf_Lmealorama_components_RecipeEditor$Props as $isArrayOf_Lmealorama_components_RecipeEditor$Props };
var $d_Lmealorama_components_RecipeEditor$Props = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_RecipeEditor$Props, "mealorama.components.RecipeEditor$Props", ({
  kh: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_RecipeEditor$Props as $d_Lmealorama_components_RecipeEditor$Props };
//# sourceMappingURL=mealorama.components.-Recipe-Editor$-Props.js.map
